import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import AppContainerPage from "../pages/AppContainerPage/AppContainerPage";
import { LoginCallback } from "@okta/okta-react";
import SecureRoute from "./SecureRoute";
import HomePage from "../pages/HomePage/HomePage";
import AboutChatbot from "../pages/AboutChatbot/AboutChatbot";
import History from "../pages/History/History";
import EngagementHistory from "../pages/EngagementHistory/EngagementHistory";
import CloseOutRequest from "../components/CloseoutRequest/CloseOutRequest";
import ChatAssistant from "../pages/ChatAssistant/ChatAssistant";
import ConsultingHomePage from "../pages/ConsultingHomePage/ConsultingHomePage";
import UserList from "../pages/users/UsersList/UserList";
import Profile from "../pages/users/Profile/Profile";
import CustomPDFViewer from "../pages/ChatAssistant/SourceCitation/CustomPDFViewer/CustomPDFViewer";
import NotFound from "../pages/NotFound/NotFound";
import HealthCheck from "../pages/HealthCheck/HealthCheck";

function AppRouter() {
  return (
    <Routes>
      <Route path="/authorization_code/callback" element={<LoginCallback />} />
      <Route path="/" element={<AppContainerPage />}>
        <Route
          path="/"
          element={
            <SecureRoute>
              <HomePage />
            </SecureRoute>
          }
        />
        <Route
          path="/about-chatbot"
          element={
            <SecureRoute>
              <AboutChatbot />
            </SecureRoute>
          }
        />
        <Route
          path="/history"
          element={
            <SecureRoute>
              <History />
            </SecureRoute>
          }
        />
        <Route
          path="/spend-wise-hub/engagement-history"
          element={
            <SecureRoute>
              <EngagementHistory />
            </SecureRoute>
          }
        />
        <Route
          path="/spend-wise-hub/upload-engagement_data"
          element={
            <SecureRoute>
              <CloseOutRequest />
            </SecureRoute>
          }
        />
        {/* Hide Consulting Search */}
        {/* <Route
          path="/spend-wise-hub/chat-assistant"
          element={
            <SecureRoute>
              <Outlet />
            </SecureRoute>
          }
        >
          <Route index element={<ChatAssistant />} />
          <Route path=":sessionId" element={<ChatAssistant />} />
        </Route> */}

        {/* <Route
          path="/spend-wise-hub/chat-assistant/:sessionId"
          element={
            <SecureRoute>
              <ChatAssistant />
            </SecureRoute>
          }
        /> */}
        <Route
          path="/spend-wise-hub"
          element={
            <SecureRoute>
              <ConsultingHomePage />
            </SecureRoute>
          }
        />

        <Route
          path="/user-list"
          element={
            <SecureRoute>
              <UserList />
            </SecureRoute>
          }
        />

        <Route
          path="/my-profile"
          element={
            <SecureRoute>
              <Profile />
            </SecureRoute>
          }
        />
      </Route>
      <Route
        path="/preview"
        element={
          <SecureRoute>
            <CustomPDFViewer />
          </SecureRoute>
        }
      />
      <Route path="/health" element={<HealthCheck />} />
      <Route
        path="/404"
        element={
          <SecureRoute>
            <NotFound />
          </SecureRoute>
        }
      />
      <Route
        path="*"
        element={
          <SecureRoute>
            <NotFound />
          </SecureRoute>
        }
      />
    </Routes>
  );
}

export default AppRouter;
